import React, { FunctionComponent } from 'react'
import { List } from 'antd'
import { Vehicle, VehicleLocation } from 'server'
import useVehicleLocationHistory from '../../hooks/data/useVehicleLocationHistory'
import { formatTimestamp, fromNow } from '../../utils/time'

interface IProps {
  vehicle?: Vehicle
}

const LastDeviceLocationUpdates: FunctionComponent<any> = (props: IProps) => {
  const { vehicle } = props

  const { history } = useVehicleLocationHistory(vehicle?.vehicle_id)

  const renderItem = (vl: VehicleLocation, index: number) => {
    return (
      <List.Item key={index}>
        <List.Item.Meta
          title={`${formatTimestamp(vl.update_received)} (${fromNow(vl.update_received)})`}
        />
      </List.Item>
    )
  }

  return <List header={'Last updates'} dataSource={history} renderItem={renderItem} size={'small'} />
}

export default LastDeviceLocationUpdates
